<div class="integrations row" style="padding-top: 10px;">

  <div class="col-2" style="padding-left: 5px; padding-right: 5px;">
    <div class="integration-panel">
      <p class="integration-header">Integrations</p>
      <ul style="margin-bottom: 0px">
        @for (Integration of Integrations; track Integration) {
          <li
            class="integration-category" [ngClass]="{'integrationSelected': selectedIntegration === Integration}"
          (click)="selectIntegration(Integration)">{{Integration}}</li>
        }
      </ul>
    </div>
  </div>

  <div class="integration-settings-root">
      @if (selectedIntegration === ITGlue) {
      <itglue-default-settings [inputSettings]="ITGlueSettings"></itglue-default-settings>
      }
      @if (selectedIntegration === Halo) {
      <halo-default-settings [inputSettings]="HaloSettings"></halo-default-settings>
      }
      @if (selectedIntegration === Hudu) {
      <hudu-default-settings [inputSettings]="HuduSettings"></hudu-default-settings>
      }
      @if (selectedIntegration === AssetPanda) {
      <assetpanda-default-settings [inputSettings]="AssetPandaSettings"></assetpanda-default-settings>
      }
      @if (selectedIntegration === Jira) {
      <jira-default-settings [inputSettings]="JiraSettings"></jira-default-settings>
      }
      @if (selectedIntegration === PatchManager) {
      <patch-manager-settings [inputSettings]="PatchManagerSettings"></patch-manager-settings>
      }
      @if (selectedIntegration === ServiceNow) {
      <service-now-default-settings [inputSettings]="ServiceNowSettings"></service-now-default-settings>
      }
      @if (selectedIntegration === NinjaOne) {
      <ninja-one-default-settings [inputSettings]="NinjaOneSettings"></ninja-one-default-settings>
      }
      @if (selectedIntegration === Lucidchart) {
      <lucidchart-default-settings [inputSettings]="LucidchartSettings"></lucidchart-default-settings>
      }
      @if (selectedIntegration === Slack) {
      <slack-default-settings [inputSettings]="SlackSettings"></slack-default-settings>
      }
  </div>

</div>